const EmptyPage = () => {
    return (
        <main id="contents">
            <div className="sub-content">
                <div className="page-empty-wrap">
                    <div className="w-set">
                        <div className="page-empty">
                            <strong>현재 해당 자료를 검토중입니다.</strong>
                            <p>보다 좋은 서비스를 제공하기 위해 해당 자료를 검토중입니다. <br/>빠른 시일 내에 찾아 뵙겠습니다. </p>
                            <p>감사합니다.</p>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default EmptyPage;
